import { Button, Table } from "react-bootstrap";
import { Pencil, Trash } from "react-bootstrap-icons";
import { Currency } from "../../../../lib/components/Currency";
import { EmptyRow } from "./EmptyState";

function getAdjustmentId(adjustment) {
  return (
    adjustment?.payoutRunAgentAdjustmentId ??
    adjustment?.agentAdjustmentId ??
    adjustment?.id ??
    null
  );
}

export function AdjustmentsSubTable({
  adjustments,
  isLocked,
  onEdit,
  onDelete,
  deletingAdjustmentIds,
}) {
  return (
    <Table
      hover
      responsive
      className="data-table data-table--interactive mb-0 align-middle"
      striped
    >
      {adjustments.length > 0 && (
        <thead>
          <tr>
            <th>Reason</th>
            <th className="col-money">Amount</th>
            <th className="col-actions col-sticky">Actions</th>
          </tr>
        </thead>
      )}
      <tbody>
        {adjustments.length === 0 ? (
          <EmptyRow colSpan={3} text="No adjustments." />
        ) : (
          adjustments.map((a, i) => {
            const adjustmentId = getAdjustmentId(a);
            const isDeleting =
              adjustmentId != null && deletingAdjustmentIds?.has(adjustmentId);

            return (
              <tr key={adjustmentId || i}>
                <td>{a.reason || "-"}</td>
                <td className="col-money tnum">
                  <Currency amount={a.adjustmentAmount} />
                </td>
                <td className="col-actions col-sticky">
                  {isLocked ? (
                    <span className="text-muted small">Locked</span>
                  ) : (
                    <div className="record-actions">
                      <Button
                        size="sm"
                        variant="link"
                        onClick={() => onEdit?.(a)}
                        className="record-action-inline record-action-icon-btn"
                        disabled={isDeleting}
                        title="Adjust amount"
                        aria-label="Adjust amount"
                      >
                        <Pencil size={16} />
                      </Button>
                      <Button
                        size="sm"
                        variant="link"
                        onClick={() => onDelete?.(a)}
                        className="record-action-inline record-action-icon-btn"
                        disabled={isDeleting}
                        title="Delete adjustment"
                        aria-label="Delete adjustment"
                      >
                        <Trash size={16} />
                      </Button>
                    </div>
                  )}
                </td>
              </tr>
            );
          })
        )}
      </tbody>
    </Table>
  );
}
